import React from "react";
import "./GrampanchayatInfo.css";

const GrampanchayatInfo = () => {
  return (
    <div className="info-container">

      <h1 className="main-title">***मुख्यमंत्री समृद्ध पंचायतराज अभियान***</h1>

      {/* ग्रामगव्हरणी माहिती */}
      <h2 className="title">गावनिहाय माहिती</h2>
      <ul className="info-list">
        <li><strong>ग्रामपंचायत नाव :</strong> भालेवाडी</li>
        <li><strong>गाव :</strong> भालेवाडी, धावडी बु, धावडी खु, नागलवाड़ी , दाभा</li>
        <li><strong>लोकसंख्या :</strong> 1998 (स्त्री : 1094 | पुरुष : 984)</li>
      </ul>



        <h3 className="section-title">1) ग्रामपंचाय (सरपंच-कार्यकाल) </h3>
      <table className="info-table">
        <thead>
          <tr>
            <th>अ.क्र.</th>
            <th>नाव</th>
            <th>वर्ष</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>१</td><td>श्री लक्ष्मण टोपाले</td><td>1965</td></tr>
          <tr><td>२</td><td>श्री माधोराव धोडाबा चौधरी </td><td>1970-78</td></tr>
          <tr><td>३</td><td> श्री गोविंदा धनु चोपड़े </td><td>1979</td></tr>
          <tr><td>४</td><td> श्री भीमराव कृष्ण ढोले</td><td>1984</td></tr>
          <tr><td>५</td><td>श्री साहेबराव गोविंगा दुपारे  </td><td>1989</td></tr>
          <tr><td>6</td><td>श्री रूपाराव सोनटक्के </td><td>1994</td></tr>

          <tr><td>7</td><td>श्री रामभाऊ यादोराव भोसले </td><td>1999</td></tr>
          <tr><td>8</td><td> श्रीमती शकुंतला आनंदराव उइके </td><td>2004</td></tr>
          <tr><td>9</td><td>श्रीमती गीताबाई गंगाधर दुपारे </td><td>2008</td></tr>
          <tr><td>10</td><td>श्रीमती कल्पना मारोती चोपड़े</td><td>2014</td></tr>
          <tr><td>12</td><td>श्री विकास सुरेश दुपारे</td><td>2019 to 2024</td></tr>
        </tbody>
      </table>



      {/* 1) प्रशासन सुसज्ज पंचायत */}
      <h3 className="section-title">2) शाश्वासन सुसज्ज पंचायत (लोकाभिमुख सशक्त पंचायत प्रशासन Governance साकार करणे)</h3>
      <table className="info-table">
        <thead>
          <tr>
            <th>अ.क्र.</th>
            <th>नाव</th>
            <th>पद</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>१</td><td>राजू गोवर्धन शेंदरे</td><td>"गटप्रमुख"</td></tr>
          <tr><td>२</td><td>ललित सुधाकर चेर</td><td>सदस्य</td></tr>
          <tr><td>३</td><td>सुरेश रामभाऊ दुपारे</td><td>सदस्य</td></tr>
          <tr><td>४</td><td>संगीता गेंद्रराज टोपले</td><td>सदस्य</td></tr>
          <tr><td>५</td><td>विकास सुरेश दुपारे</td><td>सदस्य</td></tr>
        </tbody>
      </table>

      {/* 2) सशक्त पंचायत समिती */}
      <h3 className="section-title">3) सशक्त पंचायत समिती</h3>
      <table className="info-table">
        <thead>
          <tr>
            <th>अ.क्र.</th>
            <th>नाव</th>
            <th>पद</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>१</td><td>"प्रदिप संजय चोपडे"</td><td>गटप्रमुख</td></tr>
          <tr><td>२</td><td>"ललित सुधाकर चेर"</td><td>सदस्य</td></tr>
          <tr><td>३</td><td>गोपाल तेजराव चौधरी"</td><td>सदस्य</td></tr>
          <tr><td>४</td><td>"प्रतिक्षा किशोर टोपले"</td><td>सदस्य</td></tr>
          <tr><td>५</td><td>रोशनी संजय कवाडे</td><td>सदस्य</td></tr>
        </tbody>
      </table>

      {/* 3) जल स्वच्छता समिती */}
      <h3 className="section-title">4) जल स्वच्छता समिती</h3>
      <table className="info-table">
        <thead>
          <tr>
            <th>अ.क्र.</th>
            <th>नाव</th>
            <th>पद</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>१</td><td> नरेश अजाब चोपडे</td><td>गटप्रमुख </td></tr>
          <tr><td>२</td><td> सुखदेवबाबूलाल सटवे</td><td>सदस्य</td></tr>
          <tr><td>३</td><td> जितेंद्र लमण हजारे</td><td>सदस्य</td></tr>
          <tr><td>४</td><td> ऋषिकेशा प्रभाकर उईके</td><td>सदस्य</td></tr>
          <tr><td>५</td><td>संदीप नामदेव किनकर</td><td>सदस्य</td></tr>
        </tbody>
      </table>

      <h3 className="section-title">5) मनरेगा व इत्तर योजनांचे अभिसरण करणे</h3>
      <table className="info-table">
        <thead>
          <tr>
            <th>अ.क्र.</th>
            <th>नाव</th>
            <th>पद</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>१</td><td> पंकज रमेश चौधरी</td><td>गटप्रमुख (रोजगार सेवक)</td></tr>
          <tr><td>२</td><td>पवन मनहोर खवासी</td><td>सदस्य</td></tr>
          <tr><td>३</td><td> उमेश हेमराज चोपडे</td><td>सदस्य</td></tr>
          <tr><td>४</td><td> राधा राजेश वंजारी</td><td>सदस्य</td></tr>
          <tr><td>५</td><td>विकी योगेश गायकवाड</td><td>सदस्य</td></tr>
        </tbody>
      </table>



      <h3 className="section-title">6) गावपातळीवर संस्था सक्षमीकरण करणे</h3>
      <table className="info-table">
        <thead>
          <tr>
            <th>अ.क्र.</th>
            <th>नाव</th>
            <th>पद</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>१</td><td> शशिकला गोपाल चोपडे</td><td>गटप्रमुख (रोजगार सेवक)</td></tr>
          <tr><td>२</td><td>मनीषा श्रवण चौधरी</td><td>सदस्य</td></tr>
          <tr><td>३</td><td> वनिता धनराज खवशी</td><td>सदस्य</td></tr>
          <tr><td>४</td><td> भारती तुषार वाघे</td><td>सदस्य</td></tr>
          <tr><td>५</td><td>योगिता गजानन खवशी</td><td>सदस्य</td></tr>
        </tbody>
      </table>


      <h3 className="section-title">7) उपजीविका विकास, सामाजिक न्याय</h3>
      <table className="info-table">
        <thead>
          <tr>
            <th>अ.क्र.</th>
            <th>नाव</th>
            <th>पद</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>१</td><td> कल्पना फकीरचंद चौधरी</td><td>बचत गट CRP</td></tr>
          <tr><td>२</td><td>अंजना पंजाब उईके</td><td>अंगणवाडी सेविका</td></tr>
          <tr><td>३</td><td> रमाबाई हेमराज दुपारे</td><td>अंगणवाडी सेविका</td></tr>
          <tr><td>४</td><td> देवका रमेश शाहू</td><td>अंगणवाडी सेविका</td></tr>
          <tr><td>५</td><td>शुभांगी राजेंद्र डोबले</td><td></td></tr>
        </tbody>
      </table>


      <h3 className="section-title">8)  लोकसहभाग वि श्रमदान मध्यमातून लोकचवल निर्माण करणे</h3>
      <table className="info-table">
        <thead>
          <tr>
            <th>अ.क्र.</th>
            <th>नाव</th>
            <th>पद</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>१</td><td> राजेश तुळशीराम वंजारी </td><td>गटप्रमुख</td></tr>
          <tr><td>२</td><td>योगेश राघोजी डोंगरे</td><td>सदस्य</td></tr>
          <tr><td>३</td><td> पंचफुला छत्रधर उईके</td><td>सदस्य</td></tr>
          <tr><td>४</td><td> दुर्गा श्रीराम कामडी</td><td>सदस्य</td></tr>
          <tr><td>५</td><td>अर्चना गोपाल चौधरी</td><td>सदस्य</td></tr>
          <tr><td>6</td><td>विठ्ठल भाऊरव दुपारे</td><td>सदस्य</td></tr>
        </tbody>
      </table>


      <h3 className="section-title">9)  महिला सक्षमीकरण समिती</h3>
      <table className="info-table">
        <thead>
          <tr>
            <th>अ.क्र.</th>
            <th>नाव</th>
            <th>पद</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>१</td><td> सौ. यशोदा वामन पाटील </td><td>अध्यक्ष</td></tr>
          <tr><td>२</td><td>श्री. विकास सु. दुपारे</td><td>सदस्य</td></tr>
          <tr><td>३</td><td> सौ. रंजना हे. बैगणे</td><td>सदस्य</td></tr>
          <tr><td>४</td><td> सौ.पिंगला वा. कडवे</td><td>सदस्य</td></tr>
          <tr><td>५</td><td>सौ.अर्चना एन. दुपारे</td><td>सदस्य</td></tr>
          <tr><td>6</td><td>सौ. संगीता जी. चौधरी</td><td>सदस्य</td></tr>

          <tr><td>7</td><td>सौ. जयश्री प्रा. दुपारे</td><td>सदस्य</td></tr>
          <tr><td>8</td><td>सौ.प्रेरणा क. गजभिये </td><td>सदस्य</td></tr>
          <tr><td>9</td><td>सौ.सुलोचना शा. धारापुरे</td><td>सदस्य</td></tr>
          <tr><td>10</td><td>सौ. प्रतिक्षा स्.दिवाने</td><td>सदस्य</td></tr>
          <tr><td>11</td><td>श्री. राजू जी. सेंदरे</td><td>सचिव</td></tr>
        </tbody>
      </table>



      <h3 className="section-title">10)  आपत्ती व्यवस्थापन समिती</h3>
      <table className="info-table">
        <thead>
          <tr>
            <th>अ.क्र.</th>
            <th>नाव</th>
            <th>पद</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>१</td><td> सौ. यशोदा वामन पाटील </td><td>अध्यक्ष</td></tr>
          <tr><td>२</td><td>श्री. विकास सु. दुपारे</td><td>सदस्य</td></tr>
          <tr><td>३</td><td> श्री. हरिदास गो.ढोले</td><td>सदस्य</td></tr>
          <tr><td>४</td><td> श्री. शंकर सु. बोडखे</td><td>सदस्य</td></tr>
          <tr><td>५</td><td>श्री.बबलू रा. चौधरी</td><td>सदस्य</td></tr>
          <tr><td>6</td><td>श्री मोहन कामडी</td><td>सदस्य</td></tr>

          <tr><td>7</td><td>श्री. राजेश खु. दोबाळे</td><td>सदस्य</td></tr>
          <tr><td>8</td><td>श्री. उमेश हे. चोपडे </td><td>सदस्य</td></tr>
          <tr><td>9</td><td>श्री. गजेंद्र मी. टोपले</td><td>सदस्य</td></tr>
          <tr><td>10</td><td>श्री. दुर्गेश भुरे</td><td>सदस्य</td></tr>
          <tr><td>11</td><td>श्री. राजू जी. सेंदरे</td><td>सचिव</td></tr>
        </tbody>
      </table>



      <h3 className="section-title">11) ग्रामिण पाणीपुरवाठा वि स्वच्छता समिती</h3>
      <table className="info-table">
        <thead>
          <tr>
            <th>अ.क्र.</th>
            <th>नाव</th>
            <th>पद</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>१</td><td> सौ. यशोदा वामन पाटील </td><td>प्राशासक</td></tr>
          <tr><td>२</td><td>श्री. मधुकर या. चोपडे</td><td>अध्यक्ष</td></tr>
          <tr><td>३</td><td> श्री. प्रवीण टोपले</td><td>ग्रा. वी. समिती</td></tr>
          <tr><td>४</td><td> सौ. राधा रा. वंजारी</td><td>पो. पाटील</td></tr>
          <tr><td>५</td><td>श्री.लीलाधर उकांडे</td><td>बिट जमादार</td></tr>
          <tr><td>6</td><td>श्री महेश भोरटेकर </td><td>ठाणेदार</td></tr>

          <tr><td>7</td><td>श्री. राजू जी. सेंदरे</td><td>सचिव</td></tr>
          <tr><td>8</td><td>प्रणाली वावरे  </td><td>तलाठी</td></tr>
          <tr><td>9</td><td>भोजराम ने. रमधम</td><td>सदस्य</td></tr>
          <tr><td>10</td><td>प्रवीण शी. दिवाणे</td><td>सदस्य</td></tr>
          <tr><td>11</td><td>सौ.रुपाली चोपडे</td><td> म.बचतगट</td></tr>

          <tr><td>12</td><td>ताजअहमदअली शहा</td><td>अल्पसंख्या</td></tr>
          <tr><td>13</td><td>वामन गु. सोनटके</td><td> मागासवर्गीय</td></tr>
          <tr><td>14</td><td>  कामडी सर </td><td>प्रा.शाळा</td></tr>
        </tbody>
      </table>



      <h3 className="section-title">12) अंकेशन समिती </h3>
      <table className="info-table">
        <thead>
          <tr>
            <th>अ.क्र.</th>
            <th>नाव</th>
            <th>पद</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>१</td><td> सौ. यशोदा वामन पाटील </td><td>अध्यक्ष</td></tr>
          <tr><td>२</td><td>श्री. विकास दुपारे</td><td>सदस्य</td></tr>
          <tr><td>३</td><td> श्री. उमेश चोपडे</td><td>सदस्य</td></tr>
          <tr><td>४</td><td> सौ. सुखदेव सातवे</td><td>सदस्य</td></tr>
          <tr><td>५</td><td>श्री.फकीरचंद चौधरी </td><td>सदस्य</td></tr>
          <tr><td>6</td><td> चंद्रकला चौधरी</td><td>सदस्य</td></tr>

          <tr><td>7</td><td>मनीषा चौधरी </td><td>सदस्य</td></tr>
          <tr><td>8</td><td>शशिकला चोपडे </td><td>सदस्य</td></tr>
          <tr><td>9</td><td>छाया पाटील </td><td>सदस्य</td></tr>
          <tr><td>10</td><td>रंजना बैगणे</td><td>सदस्य</td></tr>
          <tr><td>11</td><td>जयश्री दुपारे </td><td> सदस्य</td></tr>

          <tr><td>12</td><td>श्री. राजू जी. सेंदरे</td><td>सचिव</td></tr>
        </tbody>
      </table>






      <h3 className="section-title">13) संत गडगे बाबा स्वच्छता समिती </h3>
      <table className="info-table">
        <thead>
          <tr>
            <th>अ.क्र.</th>
            <th>नाव</th>
            <th>पद</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>१</td><td> सौ. यशोदा वामन पाटील </td><td>अध्यक्ष</td></tr>
          <tr><td>२</td><td>श्री. विकास दुपारे</td><td>सदस्य</td></tr>
          <tr><td>३</td><td> श्री. उमेश चोपडे</td><td>सदस्य</td></tr>
          <tr><td>४</td><td> सौ. मनीषा श. चौधरी</td><td>सदस्य</td></tr>
          <tr><td>५</td><td>सौ. शशिकला गो. चोपडे </td><td>सदस्य</td></tr>
          <tr><td>6</td><td> सौ. छाया ध. पाटील</td><td>सदस्य</td></tr>

          <tr><td>7</td><td>सौ. सुशीला दि. बागडे </td><td>सदस्य</td></tr>
          <tr><td>8</td><td>सौ. योगिता ग. खवशी </td><td>सदस्य</td></tr>
          <tr><td>9</td><td>सौ. अंजना पु. पुंडईके </td><td>सदस्य</td></tr>
          <tr><td>10</td><td>सौ. रमा हे. दुपारे</td><td>सदस्य</td></tr>
          <tr><td>12</td><td>श्री. राजू जी. सेंदरे</td><td>सचिव</td></tr>
        </tbody>
      </table>

      {/* 🔽 पुढील समित्या ह्याच पद्धतीने खाली अजून add करून पूर्ण तयार करतो */}
      

    </div>
  );
};

export default GrampanchayatInfo;
